import {
  getFromSessionStorage,
  saveToSessionStorage,
} from "@/utils/localstorage";

export default {
  namespaced: true,
  state: {
    mobile: false,
    cosedQuizAlert: getFromSessionStorage("cosedQuizAlert", false),
    cosedWeightLossQuizAlert: getFromSessionStorage(
      "cosedWeightLossQuizAlert",
      false
    ),
    unreadMessagesCount: 0,
  },
  getters: {
    isMobile: (state) => state.mobile,
    isCosedQuizAlert: (state) => state.cosedQuizAlert,
    isCosedWeightLossQuizAlert: (state) => state.cosedWeightLossQuizAlert,
    getUnreadMessagesCount: (state) => state.unreadMessagesCount,
  },
  mutations: {
    setMobile(state, isMobile) {
      state.mobile = isMobile;
    },
    setUnreadMessagesCount(state, count) {
      state.unreadMessagesCount = count;
    },
    setClosedQuizAlert(state, isClosed) {
      state.cosedQuizAlert = isClosed;
      saveToSessionStorage("cosedQuizAlert", isClosed);
    },
    setCosedWeightLossQuizAlert(state, isClosed) {
      state.cosedWeightLossQuizAlert = isClosed;
      saveToSessionStorage("cosedWeightLossQuizAlert", isClosed);
    },
  },
};
